import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, ICON_BRIEFCASE_OUTLINE } from '@doveit/bricks';
import { Applicant, JobApplication } from '../../../providers/api/dtos';
import SimplePageLayout from '../../../layouts/simple-page-layout/SimplePageLayout';
import CreateJobApplicationWithApplicant from '../../containers/create-job-application-with-applicant/CreateJobApplicationWithApplicant';

const CreateJobApplicationWithApplicantPage: React.FC = () => {
  const navigate = useNavigate();

  const navigateTo = React.useCallback((_: Applicant, jobApplication: JobApplication) => {
    navigate(`/job-applications/${jobApplication.id}`);
  }, [navigate]);

  return (
    <SimplePageLayout wrapperSize="M">
      <Card paddingSize="M">
        <Card.Header
          icon={{ path: ICON_BRIEFCASE_OUTLINE }}
          title="Aggiungi candidatura"
        />
        <Card.Content>
          <CreateJobApplicationWithApplicant
            onSuccess={navigateTo}
          />
        </Card.Content>
      </Card>
    </SimplePageLayout>
  );
};

export default CreateJobApplicationWithApplicantPage;
